"use client";

import { useEffect } from "react";

const loadedFontUrls = new Set<string>();

export function QuoteThemeFontLoader({
  googleFontsUrl,
}: {
  googleFontsUrl: string;
}) {
  useEffect(() => {
    if (!googleFontsUrl || loadedFontUrls.has(googleFontsUrl)) {
      return;
    }

    const existingLink = document.querySelector(
      `link[data-quote-theme-fonts="${googleFontsUrl}"]`
    );
    if (existingLink) {
      loadedFontUrls.add(googleFontsUrl);
      return;
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = googleFontsUrl;
    link.setAttribute("data-quote-theme-fonts", googleFontsUrl);
    document.head.appendChild(link);
    loadedFontUrls.add(googleFontsUrl);
  }, [googleFontsUrl]);

  return null;
}
